module.exports = __webpack_public_path__ + "static/chemnsfreu.fba94941.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/chemnsfreu.png
// module id = 711
// module chunks = 23899280101116